export class TokenRenewResult {
    isError: boolean;
    tokenExpiration: Date;
}